import { getCenteredCoordinateForAnimation, BallPositionByDot, line, START_ANIMATION_TIME } from '../initials';
export class StartSimpleFallAnimation {
    constructor({
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;

        this.startPosition = {
            x: dots[toRowIndex][toDotIndex].dotX,
            y: dots[0][0].dotY - 50,
        };
    }

    static getAnimationSettings() {
        return {
            fromBallPositionByDot: BallPositionByDot.CENTER,
            toBallPositionByDot: BallPositionByDot.CENTER,
        };
    }

    getAnimationTime() {
        return START_ANIMATION_TIME;
    }

    animate(time) {
        const fullTime = this.getAnimationTime();
        const t = time / fullTime;

        const endDot = this.dots[this.toRowIndex][this.toDotIndex];
        const centeredStart = getCenteredCoordinateForAnimation(this.startPosition.x, this.startPosition.y);
        const centeredEnd = getCenteredCoordinateForAnimation(endDot.dotX, endDot.dotY);
        return {
            x: line(
                centeredStart.x,
                centeredEnd.x, 
                t,
            ),
            y: line(
                centeredStart.y,
                centeredEnd.y,
                t,
            ),
        };
    }
}